export const sample_flight_api_return_value = [
  {
    name: "Alisya Kaur",
    flightInformation: {
      arrivialInformation: {
        arrivalFlightNumber: "Sw1585",
        arrivalDate: "12/22/2023",
        arrivalTime: "815pm",
      },
      departureInformation: {
        departureFlightNumber: "Sw2154",
        departureDate: "12312023",
        departureTime: "1140am",
      },
    },
  },
  {
    name: "Another Test Camper",
    flightInformation: {
      arrivialInformation: {
        arrivalFlightNumber: "Sw1585",
        arrivalDate: "12/22/2023",
        arrivalTime: "815pm",
      },
      departureInformation: {
        departureFlightNumber: "Sw2154",
        departureDate: "12312023",
        departureTime: "1140am",
      },
    },
  },
];

export const another_test_response = [
  {
    camperFirstName: "Alisya",
    camperLastName: "Kaur Basra",
    flightInformation: {
      arrivialInformation: {
        arrivalFlightNumber: "Sw1585",
        arrivalDate: "12/22/2023",
        arrivalTime: "815pm",
      },
      departureInformation: {
        departureFlightNumber: "Sw2154",
        departureDate: "12312023",
        departureTime: "1140am",
      },
    },
    parentContactInformation: "upneetbir@gmail.com",
  },
  {
    camperFirstName: "Another",
    camperLastName: "Test Camper",
    flightInformation: null,
    parentContactInformation: "upneetbir@gmail.com",
  },
];
